import {
  formatGameStatus,
  getInPossession,
} from "@/utils/game";
import React from "react";
import ViewPicks from "./view-picks";
import Chip from "@/components/primitives/chip";
import Icon from "@/components/primitives/icon";
import { useGame } from "@/utils/providers/game";

export default function GameDetailScore({
  size = "lg",
  dark,
}: {
  size?: "md" | "lg";
  dark?: boolean;
}) {
  const ctx = useGame();
  const awayInPossession = getInPossession(ctx.game, "away");
  const homeInPossession = getInPossession(ctx.game, "home");
  return (
    <div className="flex justify-center flex-col items-center">
      {/* 3 COLUMN SCORE & STATUS LAYOUT */}
      <div
        className={`relative grid grid-cols-[minmax(60px,96px)_minmax(96px,100px)_minmax(60px,96px)] text-headline-lg xs:text-display-lg ${
          dark ? "text-white" : "text-secondary-300"
        } items-center relative ${ctx.isLive ? "mt-0" : "mt-6"} gap-2`}
      >
        <div className="flex justify-end items-center relative">
          {awayInPossession && (
            <div
              className={`bottom-8 absolute ${
                dark ? "fill-primary" : "fill-secondary-300"
              }`}
            >
              <Icon name="football" size="sm" />
            </div>
          )}
          {ctx.game.status !== "Scheduled" && (
            <div
              className={`flex justify-center items-center relative ${
                ctx.winner === "away" || !ctx.winner ? "opacity-100" : "opacity-60"
              }`}
            >
              {ctx.winner && ctx.winner === "away" && (
                <div className="absolute -top-6">
                  <Icon
                    name="arrow-button-down"
                    className={`${dark ? "fill-white" : "fill-dark"}`}
                  />
                </div>
              )}
              {ctx.game.awayScore}
            </div>
          )}
        </div>
        {ctx.game.status === "Scheduled" ? (
          <div className="flex justify-center">
            <ViewPicks />
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center">
            <Chip
              color={
                ctx.game.status === "Suspended" || ctx.exception
                  ? "white"
                  : ctx.closed
                  ? "dark"
                  : "primary"
              }
              size={size}
            >
              <span className="normal-case">
                {ctx.isLive ? ctx.game.statusDescription : formatGameStatus(ctx.game)}
              </span>
            </Chip>
          </div>
        )}
        <div className="flex justify-start items-center relative">
          {ctx.game.status !== "Scheduled" && (
            <div
              className={`flex justify-center items-center relative ${
                ctx.winner === "home" || !ctx.winner ? "opacity-100" : "opacity-60"
              }`}
            >
              {ctx.winner && ctx.winner === "home" && (
                <div className="absolute -top-6">
                  <Icon
                    name="arrow-button-down"
                    className={`${dark ? "fill-white" : "fill-dark"}`}
                  />
                </div>
              )}
              {ctx.game.homeScore}
            </div>
          )}
          {homeInPossession && (
            <div
              className={`bottom-8 absolute ${
                dark ? "fill-primary" : "fill-secondary-300"
              }`}
            >
              <Icon name="football" size="sm" />
            </div>
          )}
        </div>
      {ctx.game.league === "nfl" && ctx.isLive && ctx.driveStatus ? (
        <div className="uppercase text-title-bold flex flex-row justify-center items-center gap-2 absolute -bottom-6 left-0 right-0">
          <div>{ctx.driveStatus.downAndDistance}</div>
          <div className={`w-px h-3 ${dark ? "bg-white" : "bg-dark"}`}></div>
          <div>{ctx.driveStatus.territory}</div>
        </div>
      ) : (
        <></>
      )}
      </div>
    </div>
  );
}
